import { render, staticRenderFns } from "./DescriptionEffect.vue?vue&type=template&id=18a08c61&"
import script from "./DescriptionEffect.vue?vue&type=script&lang=js&"
export * from "./DescriptionEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports